export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fotograf02-de.2e53effc.png";